// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "br.rigapunteggi{display:block;margin:-10px 0;content:\" \"}", "",{"version":3,"sources":["webpack://./src/main/components/RigaPunteggi.scss"],"names":[],"mappings":"AAAA,gBACG,aAAA,CACA,cAAA,CACA,WAAA","sourcesContent":["br.rigapunteggi {\n   display: block;\n   margin: -10px 0;\n   content: \" \";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
